<template>
  <div>
    <manifest-search-card />
  </div>
</template>

<script>
import ManifestSearchCard from '#/ui/Components/ManifestSearchCard.vue';

export default {
  components: {
    ManifestSearchCard,
  },
};
</script>
